import { render, staticRenderFns } from "./FooterLogo.vue?vue&type=template&id=43af809e"
import script from "./FooterLogo.vue?vue&type=script&lang=js"
export * from "./FooterLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports